import angular from 'angular';

export class FilesInputDirective {
    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel',
        this.scope = {};        
    }

    filesInputController($scope, $state) {
    }

    link(scope, element, attrs, ngModel) { 
        element.on("change", (e) => {
            const files = element[0].files;
            ngModel.$setViewValue(files);
        });
    }
}

angular.module('syncplicity-login.directives.fileInput', [])
  .directive('filesInput', () => new FilesInputDirective());



// WEBPACK FOOTER //
// ./client/components/directives/files-input/files-input.js